export default __webpack_public_path__ + "static/4-5_HSR_Icon-c6e5e2e096be8977815b563fbfb280ec.png";